import React, { useRef, useLayoutEffect } from 'react';
import { Card, CardContent, Typography, Box, IconButton, Tooltip } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import './NewApplicantCard.css';
import { useSelector } from 'react-redux';

const NewApplicantCard = ({
  data,
  onEventHandler,
  selectedCard,
  onCheckboxChange,
  isAdvancePannel,
  isFirst,
  tooltipCardId,
  showSelectAllTip,
  onTooltipDismiss,
  setTooltipCardId,
  onDoubleClick,
}) => {
  const [showMore, setShowMore] = useState(false);
  const { systemRole } = useSelector((state) => state.Auth);
  const clickTimer = useRef(null);


  const skillcontainer = useRef(null);

  const skills = Array.isArray(data.formattedSkills)
    ? data.formattedSkills
    : [];

  const [visibleCount, setVisibleCount] = useState(skills?.length || 0);

  useLayoutEffect(() => {
    if (!skills.length) {
      setVisibleCount(0);
      setShowMore(false);
      return;
    }

    const container = skillcontainer.current;
    if (!container) return;

    const items = Array.from(container.children);
    if (!items.length) return;
    // Get row positions
    const tops = items.map((el) => el.offsetTop);
    const uniqueRows = [...new Set(tops)];
    // Case 1: all skills fit in one row
    if (uniqueRows.length === 1) {
      setVisibleCount(skills.length);
      setShowMore(false);
      return;
    }
    // Case 2: need 2 rows → calculate how many fit
    let count = skills.length;

    while (count > 0) {
      const visibleItems = items.slice(0, count + 1); // +1 for "+more"
      const rows = [...new Set(visibleItems.map((el) => el.offsetTop))];

      if (rows.length === 2) {
        setVisibleCount(count);
        setShowMore(true);
        return;
      }
      count--;
    }
    // fallback
    setVisibleCount(skills.length);
    setShowMore(false);
  }, [skills, isAdvancePannel]);

  const exp = data.yearsofExperience;

  return (
    <Card
      className={
        selectedCard?.id == data.id
          ? 'candidate-card active'
          : 'candidate-card'
      }
    >
      <div
        style={{
          display: 'flex',
          alignContent: 'space-between',
          justifyContent: 'space-between',
        }}
      >
        <Box
          className="candidate-header"
          onClick={(e) => onEventHandler('view')}
        >
          <Typography className="candidate-name">{data?.name}</Typography>
        </Box>
        {systemRole !== "Field Recruiter" && (
          <Box className="header-icons">
            <IconButton
              size="small"
              onClick={(e) => onEventHandler('newTab')}
              title="View applicant details"
            >
              {/* <OpenInNewIcon fontSize="small" /> */}
              <img
                src="/ats/assests/img/newtabIcon.svg"
                alt="new tab icon"
                style={{ width: '16px', marginLeft: '8px', marginBottom: '5px' }}
              />
            </IconButton>
            <Tooltip
              placement="bottom-start"
              open={isFirst && tooltipCardId === data.id && showSelectAllTip}
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [5, -20],
                    },
                  },
                ],
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                  }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 18, mt: "2px" }} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      lineHeight: 1.4,
                      flex: 1,
                    }}
                  >
                    <b style={{ color: '#fff' }}>Tip:</b> Double-click to select all applicants
                  </Typography>

                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onTooltipDismiss) onTooltipDismiss();
                    }}
                    sx={{
                      color: "#fff",
                      p: "2px",
                      mt: "-4px",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#3f434a",
                    color: "#fff",
                    fontSize: "14px",
                    maxWidth: 260,
                    padding: "12px 14px",
                    borderRadius: "7px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                  },
                },
                arrow: {
                  sx: {
                    color: "#3f434a",
                  },
                },
              }}
            >
              <IconButton
                size="small"
                style={{ display: selectedCard ? 'none' : 'inline-flex' }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (clickTimer.current) {
                    clearTimeout(clickTimer.current);
                    clickTimer.current = null;
                    if (onDoubleClick) onDoubleClick();
                  } else {
                    clickTimer.current = setTimeout(() => {
                      onCheckboxChange(data, !data.isChecked);
                      clickTimer.current = null;
                    }, 250);
                  }
                }}
                onMouseEnter={() => {
                  if (!sessionStorage.getItem("hasSeenSelectAllApplicantsTip") && tooltipCardId === null) {
                    if (setTooltipCardId) setTooltipCardId(data.id);
                    sessionStorage.setItem("hasSeenSelectAllApplicantsTip", "false");
                  }
                }}
              >
                {data?.isChecked ? (
                  <div>
                    <CheckBoxIcon fontSize="small" sx={{ color: 'var(--primary-bg-color)' }} />
                  </div>
                ) : (
                  <div className="newCardCheckbox">
                    <CheckBoxOutlineBlankIcon fontSize="small" />
                  </div>
                )}
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </div>
      <CardContent
        className="candidate-content"
        onClick={(e) => onEventHandler('view')}
      >
        <div
          className={`candidate-container ${!data.applicantCode &&
            !data.role &&
            data.yearsofExperience == null &&
            !data.location
            ? 'no-fields'
            : ''
            }`}
        >
          {data.applicantCode && (
            <Typography className="candidate-id b-500">
              {data.applicantCode}
            </Typography>
          )}

          {/* ROLE – always rendered */}
          <Typography className="candidate-role role-slot b-500">
            {data.role || 'Job Title : -'}
          </Typography>
          {exp !== '' && (
            <Box className="meta-info">
              <img src="/ats/assests/img/suitcaseNewApplicantCard.svg" alt="" />
              <Typography className="b-500">Experience :</Typography>

              <Typography>
                {exp > 0 ? `${exp} ${exp === 1 ? 'Year' : 'Years'}` : ' - '}
              </Typography>
            </Box>
          )}

          <Box className="meta-info">
            <img
              src="/ats/assests/img/locationIconNewApplicantCard.svg"
              alt=""
            />
            <Typography className="candidate-role">
              <span className="b-500">Location :</span>{' '}
              {data.location?.trim() || ' - '}
            </Typography>
          </Box>
        </div>

        <Box className="detail-row">
          <Typography className="label b-500">Current Company</Typography>

          <Typography className="value">
            :{' '}
            {data.company ? (
              <>
                <span className="truncate-text" title={data.company}>
                  {data.company}
                </span>
                {data.companyPeriod && (
                  <span className="period-text">({data.companyPeriod})</span>
                )}
              </>
            ) : (
              <span> -</span>
            )}
          </Typography>
        </Box>

        <Box className="detail-row">
          <Typography className="label b-500">Highest Education</Typography>

          <Typography className="value">
            :
            {data.education ? (
              <>
                <span className="truncate-text" title={data.education}>
                  {data.education}
                </span>
                {data.educationPeriod && (
                  <span className="period-text">({data.educationPeriod})</span>
                )}
              </>
            ) : (
              <span> -</span>
            )}
          </Typography>
        </Box>
        <div className="skills-section">
          {skills?.length > 0 && <p className="skills-title b-500">Skills</p>}
          <div className="skills-wrapper">
            {/* hidden measurement container */}
            <div className="skills-container measure" ref={skillcontainer}>
              {skills?.map((skill, i) => (
                <span className="chip" key={i}>
                  {skill}
                </span>
              ))}
            </div>
            {/* visible container */}
            <div className="skills-container">
              {skills?.length > 0 ? (
                <>
                  {skills.slice(0, visibleCount).map((skill, i) => (
                    <span className="chip" key={i}>
                      {skill}
                    </span>
                  ))}
                  {skills.length > visibleCount && (
                    <span
                      className="more-text"
                      style={{
                        fontSize: '12px',
                        lineHeight: '2',
                        fontStyle: 'italic',
                        color: '#000000',
                      }}
                    >
                      &nbsp;& {skills.length - visibleCount} More
                    </span>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default NewApplicantCard;
